import { useAuthStore } from '@/store/authStore';
import { useEffect, useState } from 'react';

export const useAppInit = () => {
  const [isAppInitialized, setIsAppInitialized] = useState(false);
  const [isAppLoading, setIsAppLoading] = useState(true);

  const {
    isInitialized: isAuthInitialized,
    loadSession: loadAuthSession,
    isLoading: isAuthLoading,
  } = useAuthStore();

  useEffect(() => {
    const loadAppSession = async () => {
      try {
        await loadAuthSession();
      } catch (error) {
        console.log(error);
      }

      setIsAppInitialized(true);
      setIsAppLoading(false);
    };

    if (!isAppInitialized) {
      loadAppSession();
    }
  }, [isAppInitialized, loadAuthSession]);

  /**
   * @TODO: To get the status of 'isUnderMaintenance' flag,
   * use hook/function 'useConfigStore(getMaintenanceStatus)'.
   * Hook/function are from shared 'cp-shared-stores' package.
   *
   */
  return {
    isInitialized: isAppInitialized && isAuthInitialized,
    isLoading: isAppLoading || isAuthLoading,
    isUnderMaintenance: false,
  };
};
